import React from 'react'

function DEXADev() {
  return (
    <>
      <div
        className="about-style-three-area default-padding bg-gray bg-cover"
        style={{ background: "url(assets/img/shape/banner-16.html)" }}
      >
        <div className="container">
          <h4 className="sub-title">AI writing assistant</h4>
          <h2 className="title split-text-right split-text-in-right">
            DEX Aggregator Development by Xeer Technology
          </h2>
          <div className="row">
            <div className="col-lg-6">
              <h3>Unlock Optimal Trading Across Decentralized Exchanges</h3>
              <p>
                At Xeer Technology, we specialize in building advanced DEX
                aggregators that empower users to execute trades with the best
                prices, lowest slippage, and highest liquidity by connecting to
                multiple decentralized exchanges (DEXs). Our DEX aggregator
                solutions cater to the demands of modern DeFi traders, providing
                a seamless, cost-effective, and optimized trading experience.
              </p>
              <a className="btn btn-style-one" href="#">
                Know more
              </a>
            </div>
            <div className="col-lg-6">
              <div className="about-style-three-thumb">
                <img
                  className="fade-up-anim"
                  src="https://validthemes.net/site-template/robok/assets/img/illustration/dashboard-4.jpg"
                  alt="Image Not Found"
                />
                <img
                  className="fade-up-anim"
                  src="https://validthemes.net/site-template/robok/assets/img/illustration/1.gif"
                  alt="Image Not Found"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default DEXADev
